import(/* webpackMode: "eager" */ "/app/apps/pinzap-shop/app/(buyer)/error.tsx");
